export function createRoutes() {
  return [
    {
      path: 'performance',
      name: 'performance',
      component: () => import(/* webpackChunkName: "performance" */ '@/performance/PerformanceChrome.vue'),
    },
  ];
}

export default {
  createRoutes,
};
